import { FC, useContext } from 'react'
import { Store } from '../../api/store'
import RoutingContext from '../../routes/routing-context'
import { IconButton } from '../icon-button'
import { translate } from '../internationalization'
import { NewChat } from '../new-chat'
import Sparkles from '../../assets/sparkles.svg?react'


export const HeaderTabs: FC = () => {
  const { VITE_AUTOHINT_ROUTE, VITE_CHAT_ROUTE } = import.meta.env
  const router = useContext(RoutingContext)

  const navigate = (stream_guid: string, stream__id: string) => {
    // 1. Navigate to new url
    router?.history.push(`${VITE_CHAT_ROUTE}${stream_guid}`)

    // 2. Update local-only stream.seleted field
    Store.SelectStream(stream__id)
  }

  return <div className="flex flex-col justify-between h-full">
    <div className="flex">
      <IconButton icon={Sparkles} to={VITE_AUTOHINT_ROUTE} active={window.location.pathname === VITE_AUTOHINT_ROUTE}>
        {translate('AutoHint')}
      </IconButton>
      <NewChat label={translate("DocuChat")} navigate={navigate} />
    </div>
  </div>
}
